import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth'
import settings from './settings'
import UserDetails from '@/views/Home/Users/UserDetails/index'
import BusinessDetails from '@/views/Home/Businesses/BusinessDetails/index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    auth,
    {
      path: '/',
      name: 'home',
      redirect: { name: 'users' },
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home'),
      children: [
        {
          path: 'users',
          name: 'users',
          component: () =>
            import(/* webpackChunkName: "users" */ '@/views/Home/Users'),
        },
        {
          path: 'users/:id',
          name: 'user.details',
          component: UserDetails,
        },
        {
          path: 'businesses',
          name: 'businesses',
          component: () =>
            import(/* webpackChunkName: "users" */ '@/views/Home/Businesses'),
        },
        {
          path: 'businesses/:id',
          name: 'business.details',
          component: BusinessDetails,
        },
        {
          path: 'categories',
          name: 'categories',
          component: () =>
            import(
              /* webpackChunkName: "categories" */ '@/views/Home/Categories'
            ),
        },
        {
          path: 'reports',
          name: 'reports',
          component: () => import('@/views/Home/Reports'),
        },
        {
          path: 'reports/:id',
          name: 'reports.details',
          component: () => import('@/views/Home/Reports/ReportDetails'),
        },
        {
          path: 'reports/create',
          name: 'reports.create',
          component: () => import('@/views/Home/Reports/ReportDetails'),
        },
        {
          path: 'bookings',
          name: 'bookings',
          component: () => import('@/views/Home/Bookings'),
        },
        {
          path: 'bookings/:code',
          name: 'bookings.details',
          component: () => import('@/views/Home/Bookings/BookingDetails'),
        },
        {
          path: 'bookings/create',
          name: 'bookings.create',
          component: () => import('@/views/Home/Bookings/BookingDetails'),
        },
        {
          path: 'categories/:id',
          name: 'categories.details',
          component: () =>
            import(
              /* webpackChunkName: "categories" */ '@/views/Home/Categories/CategoryDetails'
            ),
        },
        {
          path: 'tools',
          name: 'tools',
          component: () =>
            import(/* webpackChunkName: "tools" */ '@/views/Home/Tools'),
        },
        {
          path: 'tools/:id',
          name: 'tools.details',
          component: () =>
            import(
              /* webpackChunkName: "tools" */ '@/views/Home/Tools/ToolDetails'
            ),
        },
        {
          path: 'content',
          name: 'content',
          component: () =>
            import(/* webpackChunkName: "content" */ '@/views/Home/Content'),
        },
        {
          path: 'notification',
          name: 'notification',
          component: () =>
            import(
              /* webpackChunkName: "push-notification" */ '@/views/Home/Notification'
            ),
        },
        settings,
      ],
    },
  ],
})
